import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e6f274c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4e6f274c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6f274c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/lasur-lab/lasur-lab-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6f274c')) {
      api.createRecord('4e6f274c', component.options)
    } else {
      api.reload('4e6f274c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e6f274c&scoped=true", function () {
      api.rerender('4e6f274c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Hamburger/index.vue"
export default component.exports